<template lang="html">

  <VqModal
    :name="modalName"
    class="vq-modal-delete-vm">
    <template v-slot:header>
      <h2 class="modal-title">{{setTitleContext($t('components.modalDeleteUser.del'))}} <span class="is-bold">{{ $t('components.modalDeleteUser.user') }}</span></h2>
      <button
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>
    <template v-slot:content>
  <div class="forms">
    <form>
      <div class="container has-separator">
        <div class="row">
          <div v-if="isNotCurrentUser()">
            <p class="pb-5">
              {{ $t('components.modalDeleteUser.title') }} "<span class="is-bold">{{userName}}</span>"
            </p>
            <p class="is-thin">{{ $t('components.modalDeleteUser.content') }}</p>
          </div>
          <div v-else>
            <p class="pb-5">
              {{ $t('components.modalDeleteUser.cant') }}
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
    <template v-slot:footer>
  <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalDeleteUser.cancel') }}</button>
  <button
    v-if="$store.state.display_edit && isNotCurrentUser()"
    :class="{'is-loading': isFormLoading}"
    type="button"
    class="button is-small is-danger is-outline"
    @click="submit">{{ $t('components.modalDeleteUser.delete') }}
  </button>
</template>
  </VqModal>

</template>

<script lang="js">
import { mapGetters } from 'vuex';

import { eventHubMixin } from '@/mixins/event';

import USERS from '@/api/users';

import VqModal from '@/components/VqModal.vue';

export default {
  name: 'ModalDeleteUser',
  mixins: [eventHubMixin],
  components: {
    VqModal,
  },

  props: {
    currentUser: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      modalName: 'delete-user',
      context: 'delete',
      userName: '',
      deleteModalData: {
        username: '',
      },
      isFormLoading: false,
    };
  },
  mounted() {
    this.onOpenModal(this.modalName, (data) => {
      this.userName = data.username;
    });
  },
  methods: {
    isNotCurrentUser() {
      return this.currentUser.username === this.userName ? false : true
      return true
    },
    emitSuccessToaster() {
      this.emitAddToaster({
        title: this.$t('components.modalDeleteUser.toasts.success.title'),
        text: this.$t('components.modalDeleteUser.toasts.success.content'),
        state: 'success',
        // 'link': 'http://telecloud.fr'
      });
    },

    emitFailedToaster(description) {
      this.emitAddToaster({
        title: this.$t('components.modalDeleteUser.toasts.failed.title'),
        text: `${this.$t('components.modalDeleteUser.toasts.failed.content')} ${description}`,
        state: 'danger',
        // 'link': 'http://telecloud.fr'
      });
    },

    submit() {
      this.isFormLoading = true;
      this.deleteModalData.username = this.userName;
      USERS.delete(this.deleteModalData).then(
        (res) => {
          this.isFormLoading = false;
          if (res.data.delete.description == 'success') {
            this.emitSuccessToaster();
            this.$emit('deleteuser', this.deleteModalData.username);
          } else {
            this.emitFailedToaster(res.data.delete.description);
          }
          this.close();
        },
        (err) => {
          Object.assign(this.errors, err.response.data);
        },
      );
    },
    close() {
      this.emitCloseModal(this.modalName);
    },
    setTitleContext(title) {
      return title.charAt(0).toUpperCase() + title.slice(1);
    },
  },
  computed: {

  },
};
</script>

<style scoped lang="scss">
</style>
